import { toast as reactToast } from 'react-toastify';

export const toastOptions = {
    position: 'bottom-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    pauseOnFocusLoss: true,
};

const success = (message, options = toastOptions) => {
    return reactToast.success(message, options);
};

const error = (
    message = 'Something went wrong. Please try again or contact support.',
    options = toastOptions
) => {
    return reactToast.error(message, options);
};

const warn = (message, options = toastOptions) => {
    return reactToast.warn(message, options);
};

const info = (message, options = toastOptions) => {
    return reactToast.info(message, options);
};

const toast = {
    info,
    success,
    error,
    warn,
};

export default toast;
